const KeenSlider = window.KeenSlider

const { setInitialised, useDots } = window.BAO.Carousel.plugins

class RewardsCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    this.onCarouselUpdated = this.onCarouselUpdated.bind(this)

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        initial: ~~this.dataset.slideIndex,
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1,
          spacing: 10,
          origin: 'center',
        },
        breakpoints: {
          '(min-width: 901px)': {
            disabled: true,
          },
        },
        created: this.onCarouselUpdated,
        updated: this.onCarouselUpdated,
      },
      [setInitialised(), useDots(this.els?.dot?.elements)],
    )
  }

  onCarouselUpdated (instance) {
    this.els.slides.element.setAttribute(
      `data-active-carousel`,
      instance.track.details.length !== 0,
    )
  }
}

if (!customElements.get('rewards-carousel')) {
  customElements.define('rewards-carousel', RewardsCarousel)
}
